import * as React from 'react';
import { ColumnProps } from 'antd/lib/table';
import { Account } from 'Core/Api/Api';
import SimpleTable from 'components/Forms/DataGrid/SimpleTable';
import JcsdAccountHandler from '../../JcsdAccountHandler';
import { NavLink } from 'react-router-dom';
import DetailsData from 'Core/models/DetailsData';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import DetailsMode from '../../../../Core/models/DetailsMode';
import { Button } from 'antd';
export interface Props {
    children?: React.ReactNode;
}

export interface State {
    countries: IFilterSelectOption[];
    jurisdictions: IFilterSelectOption[];
    roles: IFilterSelectOption[];
}

export default class JcsdAccountListTable extends React.Component<Props, State> {
    handler: JcsdAccountHandler;

    constructor(props: Props) {
        super(props);

        this.state = {
            countries: [],
            jurisdictions: [],
            roles: [],
        };
        this.handler = new JcsdAccountHandler(props);
    }

    componentDidMount() {

    }

    userListTableColumns: Array<ColumnProps<Account>> = [
        {
            title: 'Account Name',
            dataIndex: 'name',
            sorter: false,
        },
        {
            title: 'Account Number',
            dataIndex: 'jcsdNumber',
            sorter: false,
        },
        {
            title: 'Broker',
            dataIndex: 'broker.name',
            sorter: false,
        },

        {
            title: '',
            render: (text: any, record: Account, index: number) => {
                return (
                    <>
                        <Button type={'link'}> <NavLink
                            to={{
                                pathname: 'jcsd-accounts/' + record.id,
                                state: new DetailsData(DetailsMode.View, record.id),
                            }}>
                            View
          </NavLink>
                        </Button>

                        <Button type={'link'}>
                            <NavLink
                                to={{
                                    pathname: 'jcsd-accounts/' + record.id,
                                    state: new DetailsData(DetailsMode.Edit, record.id),
                                }}>
                                Edit
          </NavLink>
                        </Button>

                    </>
                );
            },
        },
    ];

    render() {
        return (
            <SimpleTable<Account>
                size='middle'
                scroll={{ x: true }}
                tableKey="id"
                dataFetcher={this.handler}
                columns={this.userListTableColumns}

            />
        );
    }
}



